<template>
  <layout v-if="!isLoading" :title="$t('help.title')" :sub-title="$test.fullLabel">
    <template slot="container">
      <b-container class="mt-2">
        <b-row class="mb-5">
          <b-col>
            <help-video />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="$t('help.video_help')" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="$t(`help.${$helper.isPlayerPrepa ? 'prepa_recommandations' : 'recommandations'}`)" />
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-4">
          <b-col sm="6">
            <b-button :to="{ name: 'logout' }" variant="light" block>
              {{ $t('actions.quit_test') }}
            </b-button>
          </b-col>
          <b-col sm="6">
            <form v-loading="`<i class='ti ti-refresh ti-spin'></i>`" @submit.prevent="onInitTestSubmit()">
              <b-button block type="submit">
                {{ $t('actions.start_test') }}
              </b-button>
            </form>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </layout>
  <loader-text v-else :title="$t('loading')" />
</template>

<script>
  import Layout from '@/views/Layout';
  import LoaderText from '@/components/loader-text';
  import HelpVideo from '@/components/help-video';
  import LoadOnNavigate from '@/mixins/load-on-navigate';

  export default {
    name: 'HelpView',
    components: {
      Layout,
      LoaderText,
      HelpVideo,
    },
    mixins: [
      LoadOnNavigate,
    ],
    data() {
      return {
        isLoading: null,
      };
    },
    methods: {
      async load() {
        // do nothing
      },
      async onInitTestSubmit() {
        if (true) {
          this.$root.$children[0].setFullScreen();
        }
        return this.$test.getInitTest().then(() => {
          this.$router.push({ name: 'advertising' });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>
